import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { arSystemadminUtanSimulering } from '../utils/systemadminVy';

/* Släpper bara igenom plattformens systemadmin (se utils/systemadminVy.js).
   Övriga skickas till startsidan — vyn ska inte ens avslöja att den finns. */
export default function SystemadminRoute({ children }) {
  const { user, loading } = useAuth() || {};
  if (loading) return null;
  if (!arSystemadminUtanSimulering(user)) return <Navigate to="/home/overview" replace />;
  return children;
}
